/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2026 Valerii Chupurnov. All rights reserved. https://xdsoft.net
 */

// Spanish (Español)

export default {
	'Type something': 'Escriba algo...',
	Advanced: 'Avanzado',
	'About Jodit': 'Acerca de Jodit',
	'Jodit Editor': 'Jodit Editor',
	"Jodit User's Guide": 'Guía de usuario Jodit',
	'contains detailed help for using': 'contiene ayuda detallada para el uso.',
	'For information about the license, please go to our website:':
		'Para información sobre la licencia, por favor visite nuestro sitio:',
	'Buy full version': 'Compre la versión completa',
	'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
		'Copyright © XDSoft.net - Chupurnov Valeriy. Todos los derechos reservados.',
	Anchor: 'Anclar',
	'Open in new tab': 'Abrir en nueva pestaña',
	'Open in fullsize': 'Abrir editor en pantalla completa',
	'Clear Formatting': 'Limpiar formato',
	'Fill color or set the text color': 'Color de relleno o de letra',
	Redo: 'Rehacer',
	Undo: 'Deshacer',
	Bold: 'Negrita',
	Italic: 'Cursiva',
	'Insert Unordered List': 'Insertar lista no ordenada',
	'Insert Ordered List': 'Insertar lista ordenada',
	'Align Center': 'Alinear Centrado',
	'Align Justify': 'Alinear Justificado',
	'Align Left': 'Alinear Izquierda',
	'Align Right': 'Alinear Derecha',
	'Insert Horizontal Line': 'Insertar línea horizontal',
	'Insert Image': 'Insertar imagen',
	'Insert file': 'Insertar archivo',
	'Insert youtube/vimeo video': 'Insertar video de Youtube/vimeo',
	'Insert link': 'Insertar vínculo',
	'Font size': 'Tamaño de letra',
	'Font family': 'Familia de letra',
	'Insert format block': 'Insertar bloque',
	Normal: 'Normal',
	'Heading 1': 'Encabezado 1',
	'Heading 2': 'Encabezado 2',
	'Heading 3': 'Encabezado 3',
	'Heading 4': 'Encabezado 4',
	Quote: 'Cita',
	Code: 'Código',
	Insert: 'Insertar',
	'Insert table': 'Insertar tabla',
	'Decrease Indent': 'Disminuir sangría',
	'Increase Indent': 'Aumentar sangría',
	'Select Special Character': 'Seleccionar caracter especial',
	'Insert Special Character': 'Insertar caracter especial',
	'Paint format': 'Copiar formato',
	'Change mode': 'Cambiar modo',
	Margins: 'Márgenes',
	top: 'arriba',
	right: 'derecha',
	bottom: 'abajo',
	left: 'izquierda',
	Styles: 'Estilos CSS',
	Classes: 'Clases CSS',
	Align: 'Alinear',
	Right: 'Derecha',
	Center: 'Centrado',
	Left: 'Izquierda',
	'--Not Set--': '--No Establecido--',
	Src: 'Fuente',
	Title: 'Título',
	Alternative: 'Texto Alternativo',
	Filter: 'Filtrar',
	Link: 'Vínculo',
	'Open link in new tab': 'Abrir vínculo en nueva pestaña',
	Image: 'Imagen',
	file: 'Archivo',
	'Image properties': 'Propiedades de imagen',
	Cancel: 'Cancelar',
	Ok: 'Aceptar',
	'Your code is similar to HTML. Keep as HTML?':
		'El código es similar a HTML. ¿Mantener como HTML?',
	'Paste as HTML': 'Pegar como HTML?',
	Keep: 'Mantener',
	Clean: 'Limpiar',
	'Insert as Text': 'Insertar como texto',
	'Word Paste Detected': 'Pegado desde Word detectado',
	'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
		'El contenido pegado proviene de un documento de Microsoft Word/Excel. ¿Desea mantener el formato o limpiarlo?',
	'Insert only Text': 'Insertar solo texto',
	'File Browser': 'Buscar archivo',
	'Error on load list': 'Error al cargar la lista',
	'Error on load folders': 'Error al cargar las carpetas',
	'Are you sure?': '¿Está seguro?',
	'Enter Directory name': 'Entre nombre de carpeta',
	'Create directory': 'Crear carpeta',
	'type name': 'Entre el nombre',
	'Drop image': 'Soltar imagen',
	'Drop file': 'Soltar archivo',
	'or click': 'o click',
	'Alternative text': 'Texto alternativo',
	Browse: 'Buscar',
	Upload: 'Subir',
	Background: 'Fondo',
	Text: 'Texto',
	Top: 'Arriba',
	Middle: 'Centro',
	Bottom: 'Abajo',
	'Insert column before': 'Insertar columna antes',
	'Insert column after': 'Interar columna después',
	'Insert row above': 'Insertar fila arriba',
	'Insert row below': 'Insertar fila debajo',
	'Delete table': 'Borrar tabla',
	'Delete row': 'Borrar fila',
	'Delete column': 'Borrar columna',
	'Empty cell': 'Vaciar celda',
	Delete: 'Borrar',
	'Strike through': 'Tachado',
	Underline: 'Subrayado',
	Break: 'Pausa',
	'Search for': 'Buscar',
	'Replace with': 'Reemplazar con',
	Replace: 'Reemplazar',
	Edit: 'Editar',
	'Vertical align': 'Alineación vertical',
	'Horizontal align': 'Alineación horizontal',
	'Sort by changed': 'Ordenar por fecha modificación',
	'Sort by name': 'Ordenar por nombre',
	'Sort by size': 'Ordenar por tamaño',
	'Add folder': 'Agregar carpeta',
	Split: 'Dividir',
	'Split vertical': 'Dividir vertical',
	'Split horizontal': 'Dividir horizontal',
	Merge: 'Mezclar',
	'Add column': 'Agregar columna',
	'Add row': 'Agregar fila',
	Border: 'Borde',
	'Embed code': 'Incluir código',
	Update: 'Actualizar',
	superscript: 'superíndice',
	subscript: 'subíndice',
	'Cut selection': 'Cortar selección',
	Paste: 'Pegar',
	'Choose Content to Paste': 'Seleccionar contenido para pegar',
	'Chars: %d': 'Caracteres: %d',
	'Words: %d': 'Palabras: %d',
	All: 'Todo',
	'Select %s': 'Seleccionar: %s',
	'Select all': 'Seleccionar todo',
	source: 'HTML',
	bold: 'negrita',
	italic: 'cursiva',
	brush: 'Brocha',
	link: 'Vínculo',
	undo: 'deshacer',
	redo: 'rehacer',
	table: 'Tabla',
	image: 'Imagen',
	eraser: 'Borrar',
	paragraph: 'Párrafo',
	fontsize: 'Tamaño de letra',
	video: 'Video',
	font: 'Letra',
	about: 'Acerca de',
	print: 'Imprimir',
	underline: 'subrayar',
	strikethrough: 'tachar',
	indent: 'sangría',
	outdent: 'quitar sangría',
	fullsize: 'Tamaño completo',
	shrink: 'encoger',
	hr: 'línea horizontal',
	ul: 'lista sin ordenar',
	ol: 'lista ordenada',
	cut: 'Cortar',
	selectall: 'Seleccionar todo',
	'Open link': 'Abrir vínculo',
	'Edit link': 'Editar vínculo',
	'No follow': 'No seguir',
	Unlink: 'Desvincular',
	Eye: 'Ver',
	pencil: 'Para editar',
	' URL': 'URL',
	Reset: 'Resetear',
	Save: 'Guardar',
	'Save as ...': 'Guardar como...',
	Resize: 'Redimensionar',
	Crop: 'Recortar',
	Width: 'Ancho',
	Height: 'Alto',
	'Keep Aspect Ratio': 'Mantener relación de aspecto',
	Yes: 'Si',
	No: 'No',
	Remove: 'Quitar',
	Select: 'Seleccionar',
	'You can only edit your own images. Download this image on the host?':
		'Solo puedes editar tus propias imágenes. ¿Descargar esta imagen en el servidor?',
	'The image has been successfully uploaded to the host!':
		'¡La imagen se ha subido correctamente al servidor!',
	palette: 'paleta',
	'There are no files': 'No hay archivos en este directorio.',
	Rename: 'renombrar',
	'Enter new name': 'Ingresa un nuevo nombre',
	preview: 'avance',
	download: 'Descargar',
	'Paste from clipboard': 'Pegar desde el portapapeles',
	"Your browser doesn't support direct access to the clipboard.":
		'Su navegador no soporta el acceso directo en el portapapeles.',
	'Copy selection': 'Selección de copia',
	copy: 'copia',
	'Border radius': 'Radio frontera',
	'Show all': 'Mostrar todos los',
	Apply: 'Aplicar',
	'Please fill out this field': 'Por favor, rellene este campo',
	'Please enter a web address': 'Por favor, introduzca una dirección web',
	Default: 'Predeterminado',
	Circle: 'Círculo',
	Dot: 'Punto',
	Quadrate: 'Cuadro',
	'Lower Alpha': 'Letra Minúscula',
	'Lower Greek': 'Griego Minúscula',
	'Lower Roman': 'Romano Minúscula',
	'Upper Alpha': 'Letra Mayúscula',
	'Upper Roman': 'Romano Mayúscula',
	Find: 'Encontrar',
	'Find Previous': 'Buscar Anterior',
	'Find Next': 'Buscar Siguiente',
	'Insert className': 'Insertar nombre de clase',
	'Press Alt for custom resizing':
		'Presione Alt para cambiar el tamaño personalizado',
	'License: %s': 'Licencia: %s'
};
